/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AdvancedEditorWarning from './AdvancedEditorWarning/index'
import Editor from './Editor/index'
import From from './From/index'
import Preview from './Preview/index'
import React from 'react'
import Subject from './Subject/index'
import SwitchEditor from './SwitchEditor/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/SendCommunication/EmailTemplateEditor/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginBottom={dtSpaceXs}
 weight="medium"
 text="Email"
/>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mb-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<From
  viewPath={`${viewPath}/From`}
/>
<Subject
  viewPath={`${viewPath}/Subject`}
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Preview
  viewPath={`${viewPath}/Preview`}
/>
<SwitchEditor
  viewPath={`${viewPath}/SwitchEditor`}
/>
<AdvancedEditorWarning
  viewPath={`${viewPath}/AdvancedEditorWarning`}
/>
</div>
</div>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--mt-3-Z1Yf8zk': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Vertical1}`}
>
<Editor
  viewPath={`${viewPath}/Editor`}
/>
</div>
</div>
{children}
</React.Fragment>)
}